export const prefixCls = 'sirius-select';
